@if (isMenu) {
  <button mat-menu-item [attr.aria-label]="'deleteFinalMail' | translate">
    <mat-icon>delete_forever</mat-icon>
    {{ 'deleteFinalMail' | translate }}
  </button>
} @else {
  <app-loading-icon-button
    label="deleteFinalMail"
    icon="delete_forever"
    [showButton]="true">
  </app-loading-icon-button>
}
